export const LIST_CLASSROOMGROUP = 'LIST_CLASSROOMGROUP';
export const LIST_CLASSROOMG_CATEGORY = 'LIST_CLASSROOMG_CATEGORY';
export const CREATE_CLASSROOMGROUP = 'CREATE_CLASSROOMGROUP';
export const SHOW_CLASSROOMGROUP = 'SHOW_CLASSROOMGROUP';
export const UPDATE_CLASSROOMGROUP = 'UPDATE_CLASSROOMGROUP';
export const DELETE_CLASSROOMGROUP = 'DELETE_CLASSROOMGROUP';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';
export const DATA_REMOVE_CLASSROOM_GROUP = 'DATA_REMOVE_CLASSROOM_GROUP';